<template>
  <span
    v-if="count"
    :class="[
      'pending-count-badge',
      `pending-count-badge--${tier}`,
      variant === 'avatar' ? 'pending-count-badge--avatar' : '',
    ]"
  >{{ label }}</span>
</template>

<script>
import { getPendingCountLabel, getPendingCountTier } from './pendingCountBadgeUtils';

export default {
  name: 'PendingCountBadge',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: 'inline',
      validator: value => ['inline', 'avatar'].includes(value),
    },
  },
  computed: {
    label() {
      return getPendingCountLabel(this.count);
    },
    tier() {
      return getPendingCountTier(this.count);
    },
  },
};
</script>

<style lang="scss" scoped>
.pending-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f5222d;
  color: #fff;
  line-height: 1;
  flex-shrink: 0;
  padding: 0;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px #fff;
  font-variant-numeric: tabular-nums;

  &--s {
    width: 14px;
    height: 14px;
    font-size: 9px;
  }

  &--m {
    width: 18px;
    height: 18px;
    font-size: 8px;
  }

  &--l {
    width: 20px;
    height: 20px;
    font-size: 7px;
  }

  &--avatar {
    position: absolute;
    top: -5px;
    right: -5px;

    &.pending-count-badge--m {
      top: -6px;
      right: -7px;
    }

    &.pending-count-badge--l {
      top: -7px;
      right: -8px;
    }
  }
}
</style>
